const Environments = Object.freeze({
  Development: 'DEVELOPMENT',
  Qa: 'QA',
  Staging: 'STAGING',
  Production: 'PRODUCTION',
});

export default Environments;
